import MessageNewContainer from './message_new_container';

const MessageNew = MessageNewContainer;
export default MessageNew;
